<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <div class="main-home-container">
    <v-container
      class="bg-landing white--text"
      fluid
      style="height: 70vh"
    >
      <v-row
        align="center"
        align-content="center"
        class="h-100"
        justify="center"
      >
        <v-col
          class="text-center align-self-center"
          cols="12"
        >
          <div :class="`text-h${AppIsSmall ? 6: 3} my-4`">
            {{ AppName }}
          </div>
        </v-col>
        <v-col
          class="text-center"
          cols="12"
        >
          <div :class="`${AppIsSmall ? 'text-body-2' : 'text-body-1'}`">
            {{ parseAttribute('homePage.landing_subtitle') }}
          </div>
        </v-col>
        <v-col cols="auto">
          <v-btn
            :to="route(APP_ROUTES.public.apply)"
            class="ma-6"
            color="primary"
            large
          >
            {{ parseAttribute('homePage.header_btn') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="brown white--text py-8"
      fluid
    >
      <v-row>
        <v-col>
          <div class="text-body-1 mb-5">
            {{ parseAttribute('homePage.section.a') }}
          </div>
          <div class="text-body-2">
            {{ parseAttribute('homePage.section.b') }}
          </div>
        </v-col>
        <v-col
          align-self="center"
          class="text-center"
          cols="12"
          sm="5"
        >
          <v-btn
            :to="route(APP_ROUTES.public.apply)"
          >
            {{ parseAttribute('homePage.header_btn') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      id="products"
      class="bg-landing white--text py-16"
      fluid
    >
      <v-row>
        <v-col cols="12">
          <div class="text-h4 text-center">
            {{ parseAttribute('homePage.products') }}
          </div>
          <v-divider class="white my-4" />
        </v-col>
        <v-col
          v-for="i in 9"
          :key="`${i}-produc3t`"
          cols="12"
          sm="4"
        >
          <v-card
            color="primary"
            elevation="8"
            hover
          >
            <v-card-text class="text-h6 white--text text-center">
              <v-avatar
                class="elevation-3"
                rounded
                size="120"
              >
                <v-img :src="`/img/landing/${i}.png`" />
              </v-avatar>

              <div class="mt-5">
                {{ parseAttribute(`homePage.services.${i - 1}.text`) }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- <v-col
          v-for="i in 9"
          :key="`${i}-product`"
          class="text-center"
          cols="12"
          sm="4"
        >
          <v-card
            color="transparent"
            flat
          >
            <v-avatar
              rounded
              size="180"
            >
              <v-img
                :src="`/img/landing/${i}.png`"
                class="ma-auto"
              />
            </v-avatar>

            <v-card-text class="text-h6 white&#45;&#45;text">
              {{ parseAttribute(`homePage.services.${i - 1}.text`) }}
            </v-card-text>
          </v-card>
        </v-col> -->
      </v-row>
    </v-container>
    <v-container
      id="about"
      class="brown white--text"
      fluid
    >
      <v-row>
        <v-col
          class="text-center py-10"
          cols="12"
        >
          <div
            class="text-h4 mb-5"
            v-text="parseAttribute('homePage.aboutCompany')"
          />
          <div
            class="text-body-2 mx-auto"
            style="max-width: 700px;"
            v-text="AppSettings.about_us"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-parallax
      id="vision"
      :alt="AppName"
      :height="$vuetify.breakpoint.xsOnly ? '800' : '450'"
      src="/img/landing/vision.png"
    >
      <v-overlay
        absolute
        dark
      >
        <v-container fluid>
          <v-row>
            <v-col
              v-for="c in cards"
              :key="`card-${c.title}`"
              cols="12"
              sm="6"
            >
              <v-card
                class="white--text"
                color="brown"
                style="height: 100%"
              >
                <v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="auto">
                        <v-img
                          :src="c.img"
                          class="white--text"
                          contain
                          content-class="white--text"
                          height="50"
                          width="50"
                        />
                      </v-col>
                      <v-col align-self="end">
                        <div>
                          {{ parseAttribute(c.title) }}
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <v-divider
                          class="mb-4"
                          dark
                        />
                        <div class="text-body-1 ">
                          {{ parseAttribute(c.text) }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-overlay>
    </v-parallax>

    <v-container
      id="partners"
      class="py-16 brown  white--text"
      fluid
    >
      <v-row>
        <v-col
          class="text-center"
          cols="12"
        >
          <div
            class="text-h4 mb-4"
            v-text="parseAttribute('homePage.partners')"
          />
          <div
            class="text-h6"
            v-text="parseAttribute('homePage.partners_text')"
          />
          <v-divider class="my-4 primary" />
        </v-col>
      </v-row>
      <v-row
        id="partners-logo"
      >
        <v-col
          v-for="(logo,ldx) in logos"
          :key="`partner-${ldx}`"
          cols="auto"
        >
          <v-card
            class="pa-2 align-content-center"
            height="130"
            width="130"
          >
            <v-img
              :src="logo.src"
              class="my-auto"
              contain
              eager
              max-height="100%"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="white" />
    <v-container
      id="clients"
      class="py-16 brown  white--text"
      fluid
    >
      <v-row>
        <v-col
          class="text-center"
          cols="12"
        >
          <div
            class="text-h4 mb-4"
            v-text="parseAttribute('homePage.clients')"
          />
          <div
            class="text-h6"
            v-text="parseAttribute('homePage.clients_text')"
          />
          <v-divider class="my-4 primary" />
        </v-col>
        <v-col cols="12">
          <div id="clients-carousel">
            <v-container
              v-for="(client, cdx) in clients"
              :key="`${cdx}-client`"
            >
              <v-card>
                <v-card-text class="black--text">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-body-1">
                          {{ client.text }}
                        </div>
                      </v-col>
                      <v-col cols="auto">
                        <v-avatar
                          :color="client.color"
                          left
                          size="50"
                        >
                          <div class="text-h6">
                            {{ client.value.slice(0, 1) }}
                          </div>
                        </v-avatar>
                      </v-col>
                      <v-col
                        align-self="center"
                        cols="auto"
                      >
                        <div class="text-caption">
                          {{ client.value }}
                        </div>
                        <v-rating
                          :color="client.color"
                          :value="5"
                          dense
                          half-increments
                          readonly
                          size="20"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      id="faq"
      class="primary white--text py-16"
      fluid
    >
      <v-container>
        <div class="text-h4 text-center mb-5">
          {{ parseAttribute('homePage.faq') }}
        </div>
        <v-expansion-panels
          hover
          popout
        >
          <v-expansion-panel
            v-for="(faq,fdx) in faqs"
            :key="`${fdx}-faq`"
          >
            <v-expansion-panel-header>{{ faq.text }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ faq.value }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-container>
    <v-container
      id="contact"
      class="py-16 white--text bg-landing"
      fluid
    >
      <v-row dense>
        <v-col cols="12">
          <ContactUsData
            btn-color="white"
            color="brown"
            divider-color="white"
            title
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="$route.query.l">
      <v-row
        justify="center"
      >
        <v-col cols="auto">
          <app-btn :to="route(APP_ROUTES.auth.login)">
            {{ parseAttribute('login') }}
          </app-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import { MetaInfoMixin } from '@mixins'
import ContactUsData from '@components/landing/ContactUsData.vue'
// import Slick from 'vue-slick'

export default {
  name: 'HomePage',
  components: { ContactUsData },
  mixins: [MetaInfoMixin],
  data () {
    return {
      cards: [
        {
          title: 'homePage.vision',
          text: 'homePage.vision_text',
          img: '/img/landing/target.svg'
        },
        {
          title: 'homePage.message',
          text: 'homePage.message_text',
          img: '/img/landing/idea.svg'
        }
      ],
      logos: [
        {
          src: '/img/logos/anb.png'
        },
        {
          src: '/img/logos/bidaya.svg'
        },
        {
          src: '/img/logos/bilad.png'
        },
        {
          src: '/img/logos/costomer-protection.png'
        },
        {
          src: '/img/logos/daraltamleek.png'
        },
        {
          src: '/img/logos/fransi.png'
        },
        {
          src: '/img/logos/inma.png'
        },
        {
          src: '/img/logos/jazeera.png'
        },
        {
          src: '/img/logos/masarat2.png'
        },
        {
          src: '/img/logos/rajhi.png'
        },
        {
          src: '/img/logos/riyad.png'
        },
        {
          src: '/img/logos/sab.png'
        },
        {
          src: '/img/logos/shl.png'
        },
        {
          src: '/img/logos/simah.png'
        },
        {
          src: '/img/logos/snb.png'
        }
        // {
        //   src: '/img/logos/vision.png'
        // }
      ],
      clients: [
        {
          text: 'اشكر الاخوان في هذه الشركه على المصداقيه في التعامل والانجاز السريع واشكرهم على حسن التعامل والتفاني في خدمه العميل بكل اخلاص وامانه',
          value: 'Mohamed',
          color: 'purple'
        },
        {
          text: 'كل الشكر والتقدير على تعاملهم الراقي وسرعة التاوصل وسعة الصدر والتوضيح والتفسير لادق الامور وإعطائي حلول سريعه .. ولهم خالص الشكر والتقدير',
          value: 'عبد اللطيف',
          color: 'indigo'
        },
        {
          text: 'خدماتهم ممتازة ويهتمون في التفاصيل ودايما المصداقيه عندهم رقم واحد .. تعاملت معهم واستلمت بيتي الحمد لله ومرررة متعاونين معاي يعطيهم العافيه وربي يوفقهم',
          value: 'عبد الله',
          color: 'blue'
        },
        {
          text: 'صراحه تجربه مميزة وجميله يستاهلون كل خير رقي بالتعامل والمصداقيه .. فالكم التوفيق',
          value: 'امل',
          color: 'teal'
        },
        {
          text: 'ما شاء الله من افضل الشركات في التعامل وتسهيل الامور والاجراءات للعميل وانصح فيها وبقوه ',
          value: 'Akram',
          color: 'green'
        }
      ],
      faqs: [
        {
          text: 'وش هي الشروط الأساسية للحصول على التمويل؟',
          value: 'وظيفة ثابتة، دخل شهري كافٍ، وسجل ائتماني جيد.'
        },
        {
          text: 'أقدر أوحد أقساطي مع التمويل العقاري؟',
          value: 'نعم، توحيد الأقساط متاح لتسهيل السداد وتنظيم الالتزامات.'
        },
        {
          text: 'هل أقدر أشتري بيت تحت الإنشاء؟',
          value: 'نعم! التمويل العقاري يشمل العقارات الجاهزة وتحت الإنشاء.'
        },
        {
          text: 'هل أقدر أشترك مع أحد في القرض؟',
          value: 'أكيد! القرض التضامني يسمح لك تشارك التمويل مع قريب أو شريك.'
        },
        {
          text: 'هل فيه دفعة أولى؟',
          value: 'رح يتم توفير الدفعه الاولى بدون فوائد !'
        },
        {
          text: 'هل يشترط تحويل الراتب؟',
          value: 'تقدر تختار بتحويل بالراتب او بدون الخيارات عندك كثيرة !'
        },
        {
          text: 'كم مدة سداد التمويل العقاري؟',
          value: 'تقدر تختار المدة اللي تناسبك من 5 سنوات حتى 30 سنة!'
        },
        {
          text: 'كيف أقدر أمتلك بيت بدون ما أدفع شي ؟',
          value: 'عبر التمويل العقاري، نغطي لك حتى 100% من قيمة العقار بأقساط ميسرة!'
        }
      ]
    }
  },
  mounted () {
    const partners = $('#partners-logo')

    partners.slick({
      speed: 7000,
      // speed: 500,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 5,
      slidesPerRow: 1,
      slidesToScroll: 2,
      infinite: true,
      arrows: false,
      dots: false,
      // lazyLoad: 'progressive',
      rtl: true,
      draggable: false,
      pauseOnHover: false
      // adaptiveHeight: true
    })
    partners.on('edge', function (event, slick, direction) {
      console.log('edge was hit')
    })
    const clientsCarousel = $('#clients-carousel')
    clientsCarousel.slick({
      speed: 3500,
      autoplay: true,
      autoplaySpeed: 0,
      // cssEase: 'linear',
      slidesToShow: 2,
      slidesPerRow: 1,
      slidesToScroll: 2,
      infinite: true,
      arrows: false,
      dots: false,
      // lazyLoad: 'progressive',
      rtl: true,
      draggable: false,
      pauseOnHover: false
      // adaptiveHeight: true
    })
  }
}
</script>
